// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__NP5Cl","title":"index_title__HwfiU","desc":"index_desc__n0Zhj","cardContainer":"index_cardContainer__J4kjX","card":"index_card__Rxioq"};